export default __webpack_public_path__ + "static/media/genom@2x.1c78c93b.png";